export default {
  message: '',
  status: '',
  duration: 3500,
};
